import { call, put } from "redux-saga/effects";
import {
  deleteEmployee,
  editEmployee,
  getEmployees,
  submitEmployee,
} from "../../app/components/EmployeeManagement/helper/employeeHelper";
import {
  deleteEmployeeSuccessAction,
  editEmployeeSuccessAction,
  getEmployeeDetailsSuccessAction,
  submitEmployeeSuccessAction,
} from "./actions";

export function* employeeSaga(payload) {
  try {
    const response = yield call(submitEmployee, payload.employeeData);
    yield put(submitEmployeeSuccessAction(response.data));
  } catch (err) {}
}

export function* getEmployeeSaga(payload) {
  try {
    const response = yield call(getEmployees, payload.storeId);
    yield put(getEmployeeDetailsSuccessAction(response.data));
  } catch (err) {}
}

export function* editEmployeeSaga(payload) {
  try {
    const response = yield call(editEmployee, payload.employee);
    yield put(editEmployeeSuccessAction(response.data));
  } catch (err) {}
}

export function* deleteEmployeeSaga(employee) {
  try {
    const response = yield call(deleteEmployee, employee);
    yield put(deleteEmployeeSuccessAction(response.data));
  } catch (err) {}
}
